import { __rest } from 'tslib';
import React from 'react';
import { Title } from '@10d/tend-ui-typography';
import { Root } from './components/Root/Root.js';
import { Header } from './components/Header/Header.js';
import { Footer } from './components/Footer/Footer.js';
import { Body } from './components/Body/Body.js';
import { CloseButton } from './components/CloseButton/CloseButton.js';

const Drawer = (_a) => {
    var { title, children, footer } = _a, props = __rest(_a, ["title", "children", "footer"]);
    return (React.createElement(Root, Object.assign({}, props),
        React.createElement(Header, null,
            React.createElement(Title, { level: 'h5', margin: 0 }, title),
            React.createElement(CloseButton, null)),
        React.createElement(Body, null, children),
        React.createElement(Footer, null, footer)));
};
Drawer.displayName = 'Drawer';
Drawer.Root = Root;
Drawer.Header = Header;
Drawer.Body = Body;
Drawer.Footer = Footer;
Drawer.CloseButton = CloseButton;

export { Drawer };
//# sourceMappingURL=Drawer.js.map
